const track = (event, properties) => {
  window
  .analytics
    .track(event, properties);
};

const page = (name, properties) => {
  window
    .analytics
    .page(name, properties);
};
const identify = (userId, traits) => {
  window
    .analytics
    .identify(userId, traits);
};

const reset = () => {
  window
    .analytics
    .reset();
};

export {track, page, identify, reset};


// WEBPACK FOOTER //
// ./src/analytics.js